import React, { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../colors";

import CreateCandidateForm from "../containers/profile/Ai";


const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const ProfileAi = (props) => {
 
  return (
    <div>
      <CreateCandidateForm />
    </div>
  );
};

export default ProfileAi;
